precision highp float;
uniform vec3 colorA; 
uniform vec3 colorB; 
varying vec2 vUV;
varying vec3 vWPos;
uniform sampler2D map;
uniform sampler2D uGrid;
uniform float uAlpha;
uniform sampler2D uNoise;
uniform float uTimer;

vec4 grid(vec3 fragPos3D, float scale, bool drawAxis) {
    vec2 coord = fragPos3D.xz * scale;
    vec2 derivative = fwidth(coord);
    vec2 grid = abs(fract(coord - 0.5) - 0.5) / derivative;
    float line = min(grid.x, grid.y);
    float minimumz = min(derivative.y, 1.0);
    float minimumx = min(derivative.x, 1.0);
    vec4 color = vec4(0.2, 0.2, 0.2, 1.0 - min(line, 1.0));
    // z axis
    if(fragPos3D.x > -0.1 * minimumx && fragPos3D.x < 0.1 * minimumx)
        color.z = 1.0;
    // x axis
    if(fragPos3D.z > -0.1 * minimumz && fragPos3D.z < 0.1 * minimumz)
        color.x = 1.0;
    return color;
}


vec4 photoshop_desaturate(vec3 color)
{
    float bw = (min(color.r, min(color.g, color.b)) + max(color.r, max(color.g, color.b))) * 0.5;
    return vec4(bw, bw, bw, 1.0);
}

void main() {
  vec3 color = texture2D(map, vUV).rgb;
  vec4 color4 = vec4(color, 1.0);

  float noise = texture2D(uNoise, (vWPos.xz / 10.0) * uTimer).x;

    vec4 grid_color = texture2D(uGrid, vWPos.xz * .01 * uTimer) * noise;
    vec4 grid_color_2 = texture2D(uGrid, vWPos.xy * .05 * uTimer) * noise;

    // uGradient: {value : ResourceContainer.get_resource("gradient")},
    // uGrid: {value : ResourceContainer.get_resource("grid")},
    // uHeightmap: {value : ResourceContainer.get_resource("heightmap")},

    vec4 grid_color_blue = (grid_color + grid_color_2) * vec4(0.0, 0.0, 1.0, 1.0);

    vec4 color4BW = photoshop_desaturate(color) + grid_color_blue;
    color4BW.a = color4BW.a * 0.8 + grid_color_blue.a * 0.2 + noise * 0.1;

    //vec4 grid = grid(fragPos, 10, true);
    //color4BW = color4BW + grid;
    gl_FragColor = mix(color4, color4BW, 0.0);
    //gl_FragColor = mix(color4, color4BW, 0.0);

    //#include <premultiplied_alpha_fragment>
    //#include <tonemapping_fragment>
    //#include <encodings_fragment>
}